import {
   BIGGEST_COMPANIES_SHOW_SWITCH_BUTTON
} from '../constants/constants';

export const showBiggestCompaniesFunc = () => (
    {type: BIGGEST_COMPANIES_SHOW_SWITCH_BUTTON,}
);